// extracted by mini-css-extract-plugin
module.exports = {"subTitle":"ErrorSubtitle_subTitle__bF7OX typography_p1__jx5mn"};